/* eslint-disable max-len */
// currently we don't map llc (dev, stage) to corresponding techshed env.

export const doorTypeURLs = {
  'Interior Doors': 'https://www.homedepot.com/services/c/door-window-specialist/893e44520',
  'Exterior Doors': 'https://www.homedepot.com/services/c/door-window-specialist/893e44520',
  'Patio Doors': 'https://www.homedepot.com/services/c/door-window-specialist/893e44520',
  Windows: 'https://www.homedepot.com/services/c/door-window-specialist/893e44520'
};